import { InjectionToken } from '@angular/core';

import { ConsoleErrorReporter } from './console-error-reporter';
import type { ErrorReport } from './error-report';

/** Puerto de salida de observabilidad: los call sites solo conocen esta interfaz. */
export interface ErrorReporter {
  report(report: ErrorReport): void;
}

/**
 * Token con default de consola (tree-shakable): la app funciona sin configuración
 * extra y conectar una plataforma real es proveer otra implementación en
 * app.config.ts, sin tocar ningún call site.
 */
export const ERROR_REPORTER = new InjectionToken<ErrorReporter>('ERROR_REPORTER', {
  providedIn: 'root',
  factory: () => new ConsoleErrorReporter(),
});
